import React, { useState, createContext, useContext, useEffect } from "react";
import { languageOptions, translationStore } from "../Languages";
import Access_ControlActions from "../Actions/Access_ControlActions";
import access_ControlStore from "../Stores/Access_ControlStores";
import Access_ControlConstants from "../Constants/Access_ControlConstants";
import { useGlobalSpinnerActionsContext } from "./GlobalSpinnerContext";

const initialState = {
  language: window.navigator.language.substring(0, 2),
  translate: languageOptions[window.navigator.language.substring(0, 2)],
  // isLogged: sessionStorage.getItem('isLogged') || false,
  // selectedAnlageG: sessionStorage.getItem('eqID') || 0
  //selectedEquipmentGroupID:1
};

// const initAuthState = { isLogged: sessionStorage.getItem('isLogged') || false };
// const initAMGSelected = {
//   selectedAnlageG: sessionStorage.getItem('eqID') || 0
// };
// create the language context with default selected language
//export const GlobalContext = createContext();

const LanguageContext = createContext(initialState);
const LanguageActionsContext = createContext();

export const useLanguageContext = () => useContext(LanguageContext);
export const useLanguageActionContext = () =>
  useContext(LanguageActionsContext);

// it provides the language context to app
export function LanguageContextProvider({ children }) {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [language, setLanguage] = useState(
    sessionStorage.getItem("APP-LANGUAGE")
      ? sessionStorage.getItem("APP-LANGUAGE")
      : window.navigator.language.substring(0, 2)
  );
  const [languaegeP, setlanguaegeP] = useState({
    language: language,
    translate: translationStore[language],
    localization: null,
  });
  // const provider = {
  //   language,
  //   isLogged,
  //   selectedAnlageG,
  //   translate: translationStore[language],
  //   changeLanguage: (language) => {
  //     const newLanguage = languageOptions[language] ? language : 'de';
  //     setLanguage(newLanguage);
  //     localStorage.setItem('APP-LANGUAGE', newLanguage);
  //   },
  //   UpdateLogged: (isLogged) => {
  //     setIsLogged(isLogged);
  //     sessionStorage.setItem('isLogged', isLogged);
  //   },
  //   UpdateSelectedAnlageG: (eqID) => {
  //     setSelectedAnlageG(eqID);
  //     sessionStorage.setItem('eqID', eqID);
  //   }
  // };

  // const languaegeP = {
  //   language,
  //   translate: translationStore[language],
  // };

  const UpdateLanguage = (_language) => {
    const newLanguage = languageOptions[_language]
      ? _language
      : translationStore[window.navigator.language.substring(0, 2)];
    setLanguage(newLanguage);
    setlanguaegeP((prev) => ({
      ...prev,
      language: newLanguage,
      translate: translationStore[newLanguage],
    }));
    if (newLanguage === language && languaegeP.localization === null) {
      setGlobalSpinner(true);
      Access_ControlActions.GetLocalizationMessages(newLanguage);
    } else if (newLanguage !== language) {
      setGlobalSpinner(true);
      Access_ControlActions.GetLocalizationMessages(newLanguage);
    }
    sessionStorage.setItem("APP-LANGUAGE", newLanguage);
  };

  const updateLocalization = (_localization) => {
    setlanguaegeP((prev) => {
      return {
        ...prev,
        localization: _localization,
      };
    });
    setGlobalSpinner(false);
  };

  const actions = {
    UpdateLanguage,
    updateLocalization,
  };

  useEffect(() => {
    function getLocalizationSuccess() {
      const res = access_ControlStore.getLocalizationMessages();
      let _tempItem = {};
      if (res) {
        // Object.keys(res).forEach((element) => {
        //   _tempItem[element.split(".")[1]] = res[element];
        // });
        updateLocalization(res);
        setGlobalSpinner(false);
        // setlanguaegeP((prev) => {
        //   return {
        //     ...prev,
        //     localization: _tempItem,
        //   };
        // });
      }
    }
    function getLocalizationFailure() {
      const res = access_ControlStore.getLocalizationMessages();
      setGlobalSpinner(false);
    }
    access_ControlStore.addChangeListener(
      Access_ControlConstants.GET_LOCALIZATION_MESSAGE_SUCCESS,
      getLocalizationSuccess
    );

    access_ControlStore.addChangeListener(
      Access_ControlConstants.GET_LOCALIZATION_MESSAGE_FAILURE,
      getLocalizationFailure
    );

    // getLocalizationMessages();
    return () => {
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.GET_LOCALIZATION_MESSAGE_SUCCESS,
        getLocalizationSuccess
      );
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.GET_LOCALIZATION_MESSAGE_FAILURE,
        getLocalizationFailure
      );
    };
  }, []);

  return (
    <LanguageContext.Provider value={languaegeP}>
      <LanguageActionsContext.Provider value={UpdateLanguage}>
        {children}
      </LanguageActionsContext.Provider>
    </LanguageContext.Provider>
  );
}
